import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import InactivityChecker from "elements/InactivityChecker";
import SessionRealityCheck from "elements/SessionRealityCheck";
import { OpenRoutes, PrivateRoutes } from "routes/router";
import AppContext from "contexts/AppContext";
import Spinner from "elements/Spinner";
import Translator from "services/Translator";
// ----------------------------------------------------------------------

export default function AuthGuard(props) {
  const [isReady, setIsReady] = React.useState(false);
  const isLoggedIn = useSelector((state) => state.userAuth.isAuthenticated);

  const { updateUserAuthStatus, setLoginBonus } = React.useContext(AppContext);

  const init = async () => {
    await updateUserAuthStatus();
    setIsReady(true);
  };
  React.useEffect(() => {
    init();
  }, []);

  React.useEffect(() => {
    if (isLoggedIn) {
      setLoginBonus();
    }
  }, [isLoggedIn]);

  if (isReady) {
    const basename = "/" + Translator.getSelectedLanguage().code + "/";
    return (
      <BrowserRouter basename={basename}>
        {!isLoggedIn ? (
          <OpenRoutes {...props} />
        ) : (
          <React.Fragment>
            <InactivityChecker />
            <SessionRealityCheck />
            <PrivateRoutes {...props} />
          </React.Fragment>
        )}
      </BrowserRouter>
    );
  } else {
    return <Spinner />;
  }
}
